import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchClientsListData, fetchClientsListSuccess, fetchClientsListFailure, blockClient, blockClientSuccess, blockClientFailure, addClient, addClientSuccess, addClientFailure, editClient, editClientFailure, editClientSuccess, requestClientAccess, requestClientAccessSuccess, requestClientAccessFailure, verifyClientAccess, verifyClientAccessSuccess, verifyClientAccessFailure } from "./client.actions";
import { ClientService } from "../../core/services/client.service";
import { AuthenticationService } from "../../core/services/auth.service";
import { ToastifyService } from "../../shared/toastify-service";
import { CommonAPIService } from "../../core/services/common-api.service";


@Injectable()
export class ClientEffects {

  // Client
  fetchClientData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchClientsListData),
      mergeMap(({isblocked, limit, skip}) =>
        this.restApiService.getClientsData(isblocked, limit, skip).pipe(
          map((clientdata) => {
            return fetchClientsListSuccess({ clientdata });
          }),
          catchError((error) =>
            of(fetchClientsListFailure({ error }))
          )
        )
      ),
    ),
  );

  blockClientData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(blockClient),
      mergeMap(({ userguid, status }) =>
        this.commonApiService.blockUnblockUser(userguid, status).pipe(
          map(() => blockClientSuccess({ userguid: userguid })),
          catchError((error) => of(blockClientFailure({ error })))
        )
      )
    )
  );

  blockClientDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockClientSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Client updated successfully.");
        })
      ),
    { dispatch: false }
  );

  blockClientDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockClientFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  addClientData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addClient),
      mergeMap(({ name, email, encryptedemail, encryptedname }) =>
        this.authService.register(email, '', name, encryptedemail, encryptedname).pipe(
          map((client) => addClientSuccess({ client: client.user })),
          catchError((error) => of(addClientFailure({ error })))
        )
      )
    )
  );

  addClientDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addClientSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Sent invite successfully.");
        })
      ),
    { dispatch: false }
  );

  addClientDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addClientFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  editClientData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editClient),
      mergeMap(({ guid, data }) =>
        this.restApiService.updateClientsProfile(guid, data).pipe(
          map((client) => editClientSuccess({ client: client })),
          catchError((error) => of(editClientFailure({ error })))
        )
      )
    )
  );

  editClientDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editClientSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("User updated successfully.");
        })
      ),
    { dispatch: false }
  );

  editClientDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editClientFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  requestClientAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(requestClientAccess),
      mergeMap(({ postdata }) =>
        this.clientService.clientaccessrequest(postdata).pipe(
          map((clientaccess) => requestClientAccessSuccess({clientaccess})),
          catchError((error) => of(requestClientAccessFailure({ error })))
        )
      )
    )
  );

  requestClientAccessSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(requestClientAccessSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Token sent successfully");
        })
      ),
    { dispatch: false }
  );

  requestClientAccessFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(requestClientAccessFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  verifyClientAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(verifyClientAccess),
      mergeMap(({ postdata }) =>
        this.clientService.clientaccessverification(postdata).pipe(
          map((clientaccessdata) => verifyClientAccessSuccess({clientaccessdata})),
          catchError((error) => of(verifyClientAccessFailure({ error })))
        )
      )
    )
  );

  verifyClientAccessSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(verifyClientAccessSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Access Granted");
        })
      ),
    { dispatch: false }
  );

  verifyClientAccessFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(verifyClientAccessFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private restApiService: ClientService,
    private commonApiService: CommonAPIService,
    private authService: AuthenticationService,
    private toastifyService: ToastifyService,
    private clientService: ClientService
  ) { }
}